import { ReactNode, type JSX } from 'react';
import classNames from 'classnames';
import { DropdownMenuOption, DropdownMenuSectionOption, DropdownMenuTextOption } from '../../types';
import styles from './styles/styles.module.scss';
import DropdownMenuItem from './DropdownMenuItem';

const isDropdownMenuTextOption = (option: DropdownMenuOption): option is DropdownMenuTextOption => 'title' in option;
const isDropdownMenuSectionOption = (option: DropdownMenuOption): option is DropdownMenuSectionOption => 'sectionHeader' in option;

type DropdownMenuItemsProps = {
  className?: string;
  children?: ReactNode;
  options: DropdownMenuOption[];
};

const DropdownMenuItems = ({ className, children, options }: DropdownMenuItemsProps): JSX.Element => {
  return (
    <div className={classNames(styles.container, className)}>
      {options.map((option, index) => {
        const key = `option-${index}`;
        if (isDropdownMenuTextOption(option)) {
          return <DropdownMenuItem key={key} option={option} textVariant="text100" />;
        }
        if (isDropdownMenuSectionOption(option)) {
          return (
            <div key={key} className={styles.sectionOption}>
              <div key={key} className={styles.sectionDivider} />
              {option.sectionHeader ? <span className={styles.sectionHeader}>{option.sectionHeader}</span> : null}
            </div>
          );
        }
        return option;
      })}
      {children}
    </div>
  );
};

export default DropdownMenuItems;
